// import { required, requiredIf, helpers, email } from 'vuelidate/lib/validators';
import { accountApi } from '@/api/accountApi';
import errorCode from '../../../common/constants/errorCode';
// import { rules } from '../../../common/constants/rules';
import { mapMutations, mapActions, mapGetters } from 'vuex';
import { actionTypes } from '../../../store/action-types';
import { getterTypes } from '../../../store/getter-types';
import { mutationTypes } from '../../../store/mutation-types';
// // import geetestMixin from '../../../common/mixin/geetest';
import { geetestMixin } from '@/common/mixin/geetest-mixin';
// import { getErrorLabelMixin } from '../../../common/mixin/getErrorLabel';
// import { defaultLangCode } from '../../../common/constants/globalConfig';
import tool from '../../../common/js/tool';
import { simpleCookie } from '@/common/js/simpleCookie';
import MaxRegisterModal from '@/components/MaxRegisterModal/MaxRegisterModal';
// import GaModal from '../../../components/ga-modal/GaModal';

export default {
  name: 'login',
  mixins: [geetestMixin],
  data() {
    return {
      icon: true,
      // 表单数据
      form: {
        countryCode: '',
        // 如果没有设置谷歌校验则不填
        gaCode: '',
        geetest_challenge: '',
        geetest_seccode: '',
        geetest_validate: '',
        password: '',
        username: '',
        // 如果后台未返回40018错误码，则可不填
        validateCode: '',
        // 判断是否需要谷歌验证
        needGoogleCode: false,
        // 判断是否需要二次验证
        needSecondValid: false,
      },
      showPassword: false,
      commitLoading: false,
      // 谷歌验证码弹窗是否显示
      googleModalShow: false,
      // 二次验证弹窗是否显示
      secondValidModalShow: false,
      googleCodeModalErrorTip: '',
      secondValidModalErrorTip: '',
      // 最大登录失败次数
      maxLoginFailedCount: 3,
      // 登录失败错误次数
      loginFailedCount: 0,
      name: '',
      maxWalletModalShow: false,
      maxWalletLogo: require('@/assets/images/account/max-wallet.png'),
      maxWalletPkgType: 'LOGIN',
    };
  },
  // /* validations () {
  //   const gaCodeRule = helpers.regex('gaCode', rules.googleCode);
  //   // 动态校验  如果google弹窗弹出 就要校验gaCode
  //   let form = {
  //     username: { required },
  //     password: { required },
  //   };
  //   if (this.googleModalShow) {
  //     form.gaCode = {
  //       required,
  //       gaCodeRule,
  //     };
  //   }
  //   if (this.secondValidModalShow) {
  //     form.validateCode = {
  //       required,
  //       gaCodeRule,
  //     };
  //   }
  //   return {
  //     form: form,
  //   };
  // }, */
  // validations: {
  //   form: {
  //     username: { required, email },
  //     password: { required },
  //     gaCode: {
  //       requiredIf: requiredIf('needGoogleCode'),
  //       gaCode: rules.gaCode,
  //     },
  //     validateCode: {
  //       requiredIf: requiredIf('needSecondValid'),
  //       verifyCode: rules.verifyCode,
  //     },
  //   },
  // },
  computed: {
    ...mapGetters([getterTypes.Getter_Lang]),
  //   errorMsgs() {
  //     return {
  //       username: {
  //         required: this.$t('v.common.email.required'),
  //         email: this.$t('v.common.email.format'),
  //       },
  //       password: {
  //         required: this.$t('v.common.pwd.required'),
  //         pwdValid: this.$t('v.common.pwd.pwdValid'),
  //       },
  //       gaCode: {
  //         requiredIf: this.$t('v.common.gaCode.required'),
  //         gaCode: this.$t('v.common.gaCode.format'),
  //       },
  //       validateCode: {
  //         requiredIf: this.$t('v.common.otp.required'),
  //         verifyCode: this.$t('v.common.otp.verifyCode'),
  //       },
  //     };
  //   },
  },
  components: {
    MaxRegisterModal,
  //   GaModal,
  },
  // watch: {
  //   // 当用户输入完后自动触发登录按钮
  //   'form.gaCode'(val) {
  //     if (val && val.length === 6) {
  //       this.googleCodeModalSubmit();
  //     }
  //   },
  //   'form.validateCode'(val) {
  //     if (val && val.length === 6) {
  //       this.secondValidModalSubmit();
  //     }
  //   },
  // },
  mounted() {
    this.$refs.username.focus();
    // this.submitBtn = this.$refs.submitBtn.$el;
    // this.initGeetest();
  },
  methods: {
    ...mapMutations([
      mutationTypes.SET_USERNAME,
      mutationTypes.SET_TOKEN,
      mutationTypes.SET_EXPIRETIME,
      mutationTypes.SET_LASTUPDATETIME,
    ]),
    ...mapActions([actionTypes.GET_USERINFO_ACTION]),
    showMaxRegisterModal() {
      this.maxWalletModalShow = true;
    },
  //   showMaxWalletGAShow() {
  //     this.maxWalletGAShow = true;
  //   },

    loginSubmit() {
      let geetstData;

      if (this.geetest.showGeetest) {
        let { geetest_challenge, geetest_validate, geetest_seccode } = this.geetest.geetestSuccessData || {};
        geetstData = {
          'geetest-challenge': geetest_challenge,
          'geetest-validate': geetest_validate,
          'geetest-seccode': geetest_seccode,
          sign: this.geetest.sign,
        };
      }
      // if (this.showGeetest) {
      //   // 验证用户是否通过了极验验证，如果 不需要谷歌验证码或者需要谷歌验证码，并且谷歌验证码弹窗未显示时则进行校验
      //   if (/* (!this.form.needGoogleCode || !this.form.googleModalShow) && */!(geetest_challenge && geetest_validate && geetest_seccode)) {
      //     this.$q.notify(
      //       { color: 'negative', message: this.$t('clickBtnToValid'), icon: 'warning', position: 'top', type: 'warning' }
      //     );
      //     return;
      //   }
      // }
      let isMobile = tool.browser().mobile;
      let form = this.form;
      let requestData = {
        username: form.username,
        password: form.password,
        lang: this.Getter_Lang.code,
      };
      if (form.needGoogleCode) {
        requestData.gaCode = form.gaCode;
      }
      if (form.needSecondValid) {
        requestData.validateCode = form.validateCode;
      }

      // 清空google验证码 和 二次验证码
      form.gaCode = '';
      form.validateCode = '';
      this._requestLogin(requestData, geetstData);
    },
  //   captchaSuccessFun() {
  //     this.loginSubmit();
  //   },
  //   goToRegist() {
  //     this.$router.push('/regist');
  //   },
    async _requestLogin(requestData, geetestData) {
      try {
        this.commitLoading = true;
        let res = await accountApi.login(requestData, geetestData);
        this.commitLoading = false;
        this.googleModalShow = false;
        this.secondValidModalShow = false;

        this.processLoginSuccess(res.data);
      } catch (err) {
        this.processLoginException(err);
      }
    },
  //   // 处理登录成功
    processLoginSuccess(data) {
      window.localStorage.removeItem('txnpwd', '');
      // ***以秒为单位***
      simpleCookie.setItem('isLogin', true);
      this.SET_LASTUPDATETIME(new Date().getTime() / 1000);
      this.SET_EXPIRETIME(data.expire);
      this.SET_TOKEN(data.accessToken);
      this.SET_USERNAME(data.userName);
      const token = data.accessToken.replace('Bearer ', '');
      this.$socket.emit('authorize', token).then(response => {});

      let willJump = this.$route.query.redirect;
      // let timer
      // 获取用户详情信息
      this.GET_USERINFO_ACTION();
      if (data.phoneStatus === 0) {
        this.$router.push({ path: '/bind-phone', params: { id: 1 } });
        return;
      }
      if (willJump !== undefined) {
        // 预跳转页
        this.$router.replace(willJump);
      } else {
        // 跳转首页
        this.$router.push({ name: 'home' });
      }
    },
    // 处理登录异常
    processLoginException(err) {
      this.commitLoading = false;
      // 如果错误码为40014则说明用户开启了谷歌验证，因此在登录时就需要输入谷歌验证码
      if (err.errcode === '1904') {
        this.googleModalShow = true;
        this.form.needGoogleCode = true;
        setTimeout(() => {
          this.$refs.gaCodeInput.focus();
        }, 500);
      } else if (err.errcode === errorCode.NEED_SECOND_CODE) {
        // 如果错误码为40018：当前登录地点状况存在异常, 需要进行二次验证！
        this.form.needSecondValid = true;
        this.secondValidModalShow = true;
      } else {
        // 其他错误
        switch (err.errcode) {
          // 用户密码输入错误
          case errorCode.PWD_ERROR:
            this.geetestReset();
            this.loginFailedCount++;
            break;
          // 谷歌验证码输入错误
          case errorCode.GOOGLE_CODE_ERROR:
            this.form.needGoogleCode = false;
            this.loginFailedCount++;
            break;
          // 二次验证码输入错误
          case errorCode.SECOND_CODE_ERROR:
            this.loginFailedCount++;
            break;
          default:
            this.geetestReset();
        }
        /* if(this.loginFaildCount >= this.maxLoginFaildCount){
             this.disabled = true;
           } */
      }
    },
  //   // 谷歌验证码弹窗"确定"按钮点击事件
  //   googleCodeModalSubmit() {
  //     this.$v.form.gaCode.$touch();
  //     if (this.$v.form.gaCode.$error) {
  //       return;
  //     }
  //     this.googleModalShow = false;
  //     this.loginSubmit();
  //   },
  //   // 二次验证弹窗"确定"按钮点击事件
  //   secondValidModalSubmit() {
  //     this.$v.form.validateCode.$touch();
  //     if (this.$v.form.validateCode.$error) {
  //       return;
  //     }
  //     this.secondValidModalShow = false;
  //     this.googleModalShow = false;

  //     this.loginSubmit();
  //   },
  //   // 极验用户行为通过后回调函数
  //   onGeetestSuccess() {
  //     this.loginSubmit();
  //   },
  //   // 后台关闭极验回调函数
  //   onDisableGeetest() {
  //     this.loginSubmit();
  //   },
  //   redirectToHome() {
  //     this.$router.push({ name: 'home' });
  //   },
  },
};
